module.exports = __webpack_public_path__ + "img/icon_home_hezuo_three@3x.7ff02a92.png";